import {createSelector} from 'reselect';

const getShoppingCart = (store) => store.shoppingCart.shoppingCart || {};
const getTotalPrice = (shoppingCart) => shoppingCart.totalPrice;
const getProductSelection = (store) => store.productSelection || {};
const getProducts = (productSelection) => productSelection.products || [];
const resultsSelection = (productSelection) => productSelection.resultsSelected || false;

const productsSelector = createSelector(getProductSelection, getProducts);
const resultsSelectionSelector = createSelector(getProductSelection, resultsSelection);
const totalPriceSelector = createSelector(getShoppingCart, getTotalPrice);

export default {
    resultsSelection: (store) => resultsSelectionSelector(store),
    products: (store) => productsSelector(store),
    totalPrice: (store) => totalPriceSelector(store),
};
